<template>
  <div class="banners">
    <a
      :key="index"
      @click="jumpUrl(banner.configer)"
      class="banner"
      href="javascript:;"
      v-for="(banner, index) in banners"
    >
      <img :src="banner.configer.img" />
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'bannerList',
  props: {
    banners: {
      type: Array
    }
  },
  computed: {
    ...mapState('store', [
      'Authorization'
    ])
  },
  methods: {
    jumpUrl (arg) {
      if (arg.is_login) {
        if (this.Authorization) {
          if (arg.is_ajax) {
            this.jumpUrlHandler(arg.url)
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      } else {
        if (arg.url) {
          location.href = arg.url
        }
      }
    },
    async jumpUrlHandler (url) {
      const res = await this.$axios.get(url)
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          // console.log(data)
          window.location.href = data
        } else if (code === -1) {
          this.$router.push({ name: 'login' })
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.banners {
  min-height: 3.12rem;
}
.banner {
  width: 100%;
  margin-bottom: 0.2rem;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    object-fit: contain;
  }
}
</style>
